// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.partner-dashboard {
    border-radius: 5px;
    background-color: #fff;
}

.transactions {
    background-color: #fff;
    border-radius: 5px;
}

@media (max-width: 576px) {
    .table-responsive {
        overflow-x: auto;
        white-space: nowrap;
    }

    table {
        width: 100%;
        min-width: 600px;
    }

    th {
        position: sticky;
        top: 0;
        background: white;
        z-index: 2;
    }
}

@media (max-width: 576px) {
    .partner-dashboard {
        flex-direction: column !important;
        align-items: flex-start !important;
        gap: 8px !important;
    }

    .partner-dashboard .d-flex {
        flex-wrap: wrap !important;
        justify-content: space-between !important;
        width: 100% !important;
        gap: 6px !important;
    }

    .small-dropdown {
        width: 100% !important;
        font-size: 12px !important;
        padding: 6px !important;
    }

    .partner-dashboard .filter-btn,
    .partner-dashboard .export-btn {
        width: 48%;
        font-size: 12px !important;
        padding: 6px 6px !important;

    }
}
.revenue-container {
    width: 100%;
    overflow-x: hidden;
}

.revenue-scroll {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
}

.month-card {
    width: 24%;
}

@media (max-width: 992px) {
    .month-card {
        width: 24%;
    }
}
@media (max-width: 1440px) {
    .month-card {
        width: 22%;
    }
}
@media (max-width: 576px) {
    .revenue-container {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    .revenue-scroll {
        flex-wrap: nowrap;
        width: max-content;
    }

    .month-card {
        width: 120px;
        flex-shrink: 0;
    }
}
@media (max-width: 576px) {
    .scrollable-table-wrapper {
        overflow-x: auto;  
        -webkit-overflow-scrolling: touch;  
    }

    .earnings-table {
        min-width: 600px; 
    }
}

.transactions table {
    border-collapse: collapse;
}

.transactions table tbody tr td {
    border: none !important;
}

.transactions table thead th {
    background-color: rgb(229, 229, 234) !important;
    border: none;
}

.Payment-method {
    border-radius: 5px;
    background-color: #fff;
}

.payout_status {
    width: 100px;
    font-size: 14px;
    text-align: center;
    text-align-last: center;
}

.filter-btn {
    border-radius: 5px;
    padding: 10px 10px;
    font-size: 16px;
    display: flex;
    align-items: center;
}

.small-dropdown {
    width: auto;
    min-width: 150px;
    font-size: 14px;
    padding: 6px;
}

.partner-dashboard {
    background: #f8f9fa;
    border-radius: 8px;
    display: flex;
    align-items: center;
}

.month-card {
    transition: background-color 0.3s ease;
}

.month-card:hover {
    background-color: #E3F2FD;
}

.earnings-dropdown {
    min-width: 140px;
}

.earnings-filter-btn {
    display: flex;
    align-items: center;
    gap: 5px;
}

.earnings-table td {
    vertical-align: middle;
}

.video-icon {
    color: #007bff;
    margin-right: 8px;
}

.download-icon {
    color: #007bff;
    cursor: pointer;
}

.download-icon:hover {
    color: #0056b3;
}

.export-btn {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 14px;
}

.earnings-card {
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
}

.earnings-card table {
    border-collapse: collapse;
}

.earnings-card table thead th {
    background-color: rgb(229, 229, 234) !important;
    border: none;
    text-transform: uppercase;
    font-size: 13px !important;
}

.earnings-card table .total {
    background-color: rgb(229, 229, 234) !important;
    border: none;
    text-transform: uppercase;
    font-size: 13px !important;
}

.totalearning td {
    background-color: rgb(229, 229, 234) !important;
    border: none !important;
}

.payoutgraphic {
    background-color: #fff;
    border-radius: 5px;
}
.invoices-container {
    width: 90%;
    margin: auto;
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

@media (max-width: 576px) {
    .table-responsive {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    .invoice-table {
        width: 100%;
        table-layout: fixed; 
        border-collapse: collapse; 
    }

    .invoice-table th, 
    .invoice-table td {
        white-space: normal; 
        padding: 8px;
        font-size: 11px !important; 
        text-align: left;
        vertical-align: middle;
    }

    .invoice-table th {
        background-color: #f8f9fa;
        position: sticky;
        top: 0;
        z-index: 1;
        text-align: center; 
        padding: 10px;
    }

    .invoice-table td {
        font-size: 13px; 
        padding: 10px;
    }


}


@media (min-width: 577px) {
    .invoice-table {
        width: 100%;
        table-layout: auto; 
    }

    .invoice-table th, .invoice-table td {
        white-space: nowrap; 
    }

    .invoice-table th {
        background-color: #f8f9fa;
    }

    .invoice-table td {
        text-align: left; 
    }

    .invoice-table .text-end {
        text-align: right; 
    }

    .invoice-table .text-center {
        text-align: center; 
    }
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.header h2 {
    font-size: 24px;
}

.buttons {
    display: flex;
    gap: 10px;
}

.export-btn {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 8px 12px;
    background: #007bff;
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.export-btn:hover {
    background: #0056b3;
}
.filters {
    display: flex;
    gap: 10px;
    align-items: center;
    margin-bottom: 15px;
}

.search-input {
    flex: 1 1;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 5px;
}

.period-dropdown {
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 5px;
}

.partner-dashboard .filter-btn {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 8px 12px;
    background: #28a745;
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.partner-dashboard .filter-btn:hover {
    background: #1e7e34 !important;
}
.earnings-filter-button  {
    padding: 10px;
    display: inline-flex;
    align-items: center;
}

@media (max-width: 576px) {
    .earnings-filter-button {
        width: 100%;  
    }
}

.invoice-table {
    width: 100%;
    border-collapse: collapse;
}

 .invoice-table th,
.invoice-table td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

.invoice-table th {
    background: #f8f9fa;
}

.commission {
    color: red;
}

.payout {
    color: green;
}

.actions {
    text-align: center;
    cursor: pointer;
}

.pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
}

.page-controls {
    display: flex;
    gap: 5px;
}

.page-controls button {
    padding: 5px 10px;
    border: 1px solid #ddd;
    background: #f8f9fa;
    cursor: pointer;
    border-radius: 3px;
}

.page-controls .active {
    background: #007bff;
    color: white;
}

.invoice-filter-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 5px;
    background-color: #f8f9fa;
    gap: 20px;
}

.search-input {
    flex: 1 1;
    height: 38px;
    border-radius: 5px;
    padding: 8px;
    border: 1px solid #ddd;
}

.filter-group {
    display: flex;
    align-items: center;
    gap: 10px;
}

.period-select {
    height: 38px;
    border-radius: 5px;
    background-color: white;
    color: #333;
    border: 1px solid #ddd;
}

.invoicefilter .filter-btn {
    height: 38px;
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 8px 16px;
    font-weight: 500;
    background-color: #007bff;
    border-radius: 5px;
    color: white;
    border: none;
}

.invoicefilter .filter-btn:hover {
    background-color: #0056b3;
}

.invoicefilter table thead th {
    background-color: rgb(229, 229, 234) !important;
    border: none;
}

.invoice-table {
    border-radius: 5px !important;
}


.invoice-table-container {
    padding: 15px;
}

.invoice-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
}

.invoice-table thead th:first-child {
    border-top-left-radius: 5px;
}

.invoice-table thead th:last-child {
    border-top-right-radius: 5px;
}

.invoice-table tbody tr:last-child td:first-child {
    border-bottom-left-radius: 5px;
}

.invoice-table tbody tr:last-child td:last-child {
    border-bottom-right-radius: 5px;
}

.pagination-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border-top: 1px solid #ddd;
    margin-top: 10px;
}
/* .table-responsive {
    overflow: auto !important;
} */

.action-dropdown {
    position: relative;
    display: inline-block;
}

.action-menu {
    position: absolute;
    right: 0;
    top: 100%;
    z-index: 1000;
    display: none;
    min-width: 160px;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    padding: 8px 0;
    transition: all 0.2s ease-in-out;
    pointer-events: auto; 
}

.action-dropdown:hover .action-menu {
    display: block;
}

.action-dropdown-item {
    padding: 10px 15px;
    display: flex;
    align-items: center;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.2s ease-in-out;
}

.action-dropdown-item:hover {
    background-color: #e7e8e9 !important; 
    color: #000;
}
@media (max-width: 576px) {
    .table-wrapper {
        display: block;
        max-height: 300px; 
        overflow-y: auto; 
        overflow-x: auto; 
        position: relative;
        width: 100%;
    }

    .table thead {
        position: sticky;
        top: 0;
        background-color: #fff; 
        z-index: 10;
    }

    .table {
        width: max-content; 
        min-width: 100%; 
        table-layout: auto;
    }

    .table th, 
    .table td {
        white-space: nowrap; 
        padding: 8px 12px; 
    }
}

.custom-select-width {
    width: 300px; /* Adjust as needed */
}`, "",{"version":3,"sources":["webpack://./src/Pages/Site/Partner/Partner.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,MAAM;QACN,iBAAiB;QACjB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,iCAAiC;QACjC,kCAAkC;QAClC,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;QAC1B,yCAAyC;QACzC,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,0BAA0B;QAC1B,uBAAuB;IAC3B;;IAEA;;QAEI,UAAU;QACV,0BAA0B;QAC1B,2BAA2B;;IAE/B;AACJ;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,UAAU;IACd;AACJ;AACA;IACI;QACI,UAAU;IACd;AACJ;AACA;IACI;QACI,gBAAgB;QAChB,iCAAiC;IACrC;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;AACJ;AACA;IACI;QACI,gBAAgB;QAChB,iCAAiC;IACrC;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,+CAA+C;IAC/C,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,+CAA+C;IAC/C,YAAY;IACZ,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,+CAA+C;IAC/C,YAAY;IACZ,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,+CAA+C;IAC/C,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,iCAAiC;IACrC;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,yBAAyB;IAC7B;;IAEA;;QAEI,mBAAmB;QACnB,YAAY;QACZ,0BAA0B;QAC1B,gBAAgB;QAChB,sBAAsB;IAC1B;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;QAChB,MAAM;QACN,UAAU;QACV,kBAAkB;QAClB,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;;;AAGJ;;;AAGA;IACI;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;CAEC;;IAEG,aAAa;IACb,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,+CAA+C;IAC/C,YAAY;AAChB;;AAEA;IACI,6BAA6B;AACjC;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,0BAA0B;IAC1B,gBAAgB;AACpB;AACA;;GAEG;;AAEH;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,0CAA0C;IAC1C,cAAc;IACd,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;AACA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,MAAM;QACN,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,kBAAkB;IACtB;;IAEA;;QAEI,mBAAmB;QACnB,iBAAiB;IACrB;AACJ;;AAEA;IACI,YAAY,EAAE,qBAAqB;AACvC","sourcesContent":[".partner-dashboard {\n    border-radius: 5px;\n    background-color: #fff;\n}\n\n.transactions {\n    background-color: #fff;\n    border-radius: 5px;\n}\n\n@media (max-width: 576px) {\n    .table-responsive {\n        overflow-x: auto;\n        white-space: nowrap;\n    }\n\n    table {\n        width: 100%;\n        min-width: 600px;\n    }\n\n    th {\n        position: sticky;\n        top: 0;\n        background: white;\n        z-index: 2;\n    }\n}\n\n@media (max-width: 576px) {\n    .partner-dashboard {\n        flex-direction: column !important;\n        align-items: flex-start !important;\n        gap: 8px !important;\n    }\n\n    .partner-dashboard .d-flex {\n        flex-wrap: wrap !important;\n        justify-content: space-between !important;\n        width: 100% !important;\n        gap: 6px !important;\n    }\n\n    .small-dropdown {\n        width: 100% !important;\n        font-size: 12px !important;\n        padding: 6px !important;\n    }\n\n    .partner-dashboard .filter-btn,\n    .partner-dashboard .export-btn {\n        width: 48%;\n        font-size: 12px !important;\n        padding: 6px 6px !important;\n\n    }\n}\n.revenue-container {\n    width: 100%;\n    overflow-x: hidden;\n}\n\n.revenue-scroll {\n    display: flex;\n    gap: 1rem;\n    flex-wrap: wrap;\n}\n\n.month-card {\n    width: 24%;\n}\n\n@media (max-width: 992px) {\n    .month-card {\n        width: 24%;\n    }\n}\n@media (max-width: 1440px) {\n    .month-card {\n        width: 22%;\n    }\n}\n@media (max-width: 576px) {\n    .revenue-container {\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n    }\n\n    .revenue-scroll {\n        flex-wrap: nowrap;\n        width: max-content;\n    }\n\n    .month-card {\n        width: 120px;\n        flex-shrink: 0;\n    }\n}\n@media (max-width: 576px) {\n    .scrollable-table-wrapper {\n        overflow-x: auto;  \n        -webkit-overflow-scrolling: touch;  \n    }\n\n    .earnings-table {\n        min-width: 600px; \n    }\n}\n\n.transactions table {\n    border-collapse: collapse;\n}\n\n.transactions table tbody tr td {\n    border: none !important;\n}\n\n.transactions table thead th {\n    background-color: rgb(229, 229, 234) !important;\n    border: none;\n}\n\n.Payment-method {\n    border-radius: 5px;\n    background-color: #fff;\n}\n\n.payout_status {\n    width: 100px;\n    font-size: 14px;\n    text-align: center;\n    text-align-last: center;\n}\n\n.filter-btn {\n    border-radius: 5px;\n    padding: 10px 10px;\n    font-size: 16px;\n    display: flex;\n    align-items: center;\n}\n\n.small-dropdown {\n    width: auto;\n    min-width: 150px;\n    font-size: 14px;\n    padding: 6px;\n}\n\n.partner-dashboard {\n    background: #f8f9fa;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n}\n\n.month-card {\n    transition: background-color 0.3s ease;\n}\n\n.month-card:hover {\n    background-color: #E3F2FD;\n}\n\n.earnings-dropdown {\n    min-width: 140px;\n}\n\n.earnings-filter-btn {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.earnings-table td {\n    vertical-align: middle;\n}\n\n.video-icon {\n    color: #007bff;\n    margin-right: 8px;\n}\n\n.download-icon {\n    color: #007bff;\n    cursor: pointer;\n}\n\n.download-icon:hover {\n    color: #0056b3;\n}\n\n.export-btn {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    font-size: 14px;\n}\n\n.earnings-card {\n    background-color: #fff;\n    border-radius: 5px;\n    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.earnings-card table {\n    border-collapse: collapse;\n}\n\n.earnings-card table thead th {\n    background-color: rgb(229, 229, 234) !important;\n    border: none;\n    text-transform: uppercase;\n    font-size: 13px !important;\n}\n\n.earnings-card table .total {\n    background-color: rgb(229, 229, 234) !important;\n    border: none;\n    text-transform: uppercase;\n    font-size: 13px !important;\n}\n\n.totalearning td {\n    background-color: rgb(229, 229, 234) !important;\n    border: none !important;\n}\n\n.payoutgraphic {\n    background-color: #fff;\n    border-radius: 5px;\n}\n.invoices-container {\n    width: 90%;\n    margin: auto;\n    background: #fff;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n@media (max-width: 576px) {\n    .table-responsive {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n    }\n\n    .invoice-table {\n        width: 100%;\n        table-layout: fixed; \n        border-collapse: collapse; \n    }\n\n    .invoice-table th, \n    .invoice-table td {\n        white-space: normal; \n        padding: 8px;\n        font-size: 11px !important; \n        text-align: left;\n        vertical-align: middle;\n    }\n\n    .invoice-table th {\n        background-color: #f8f9fa;\n        position: sticky;\n        top: 0;\n        z-index: 1;\n        text-align: center; \n        padding: 10px;\n    }\n\n    .invoice-table td {\n        font-size: 13px; \n        padding: 10px;\n    }\n\n\n}\n\n\n@media (min-width: 577px) {\n    .invoice-table {\n        width: 100%;\n        table-layout: auto; \n    }\n\n    .invoice-table th, .invoice-table td {\n        white-space: nowrap; \n    }\n\n    .invoice-table th {\n        background-color: #f8f9fa;\n    }\n\n    .invoice-table td {\n        text-align: left; \n    }\n\n    .invoice-table .text-end {\n        text-align: right; \n    }\n\n    .invoice-table .text-center {\n        text-align: center; \n    }\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 15px;\n}\n\n.header h2 {\n    font-size: 24px;\n}\n\n.buttons {\n    display: flex;\n    gap: 10px;\n}\n\n.export-btn {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    padding: 8px 12px;\n    background: #007bff;\n    color: #fff;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.export-btn:hover {\n    background: #0056b3;\n}\n.filters {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    margin-bottom: 15px;\n}\n\n.search-input {\n    flex: 1;\n    padding: 8px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n}\n\n.period-dropdown {\n    padding: 8px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n}\n\n.partner-dashboard .filter-btn {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    padding: 8px 12px;\n    background: #28a745;\n    color: #fff;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.partner-dashboard .filter-btn:hover {\n    background: #1e7e34 !important;\n}\n.earnings-filter-button  {\n    padding: 10px;\n    display: inline-flex;\n    align-items: center;\n}\n\n@media (max-width: 576px) {\n    .earnings-filter-button {\n        width: 100%;  \n    }\n}\n\n.invoice-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n .invoice-table th,\n.invoice-table td {\n    padding: 12px;\n    text-align: left;\n    border-bottom: 1px solid #ddd;\n}\n\n.invoice-table th {\n    background: #f8f9fa;\n}\n\n.commission {\n    color: red;\n}\n\n.payout {\n    color: green;\n}\n\n.actions {\n    text-align: center;\n    cursor: pointer;\n}\n\n.pagination {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 15px;\n}\n\n.page-controls {\n    display: flex;\n    gap: 5px;\n}\n\n.page-controls button {\n    padding: 5px 10px;\n    border: 1px solid #ddd;\n    background: #f8f9fa;\n    cursor: pointer;\n    border-radius: 3px;\n}\n\n.page-controls .active {\n    background: #007bff;\n    color: white;\n}\n\n.invoice-filter-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    background-color: #f8f9fa;\n    gap: 20px;\n}\n\n.search-input {\n    flex: 1;\n    height: 38px;\n    border-radius: 5px;\n    padding: 8px;\n    border: 1px solid #ddd;\n}\n\n.filter-group {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.period-select {\n    height: 38px;\n    border-radius: 5px;\n    background-color: white;\n    color: #333;\n    border: 1px solid #ddd;\n}\n\n.invoicefilter .filter-btn {\n    height: 38px;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    padding: 8px 16px;\n    font-weight: 500;\n    background-color: #007bff;\n    border-radius: 5px;\n    color: white;\n    border: none;\n}\n\n.invoicefilter .filter-btn:hover {\n    background-color: #0056b3;\n}\n\n.invoicefilter table thead th {\n    background-color: rgb(229, 229, 234) !important;\n    border: none;\n}\n\n.invoice-table {\n    border-radius: 5px !important;\n}\n\n\n.invoice-table-container {\n    padding: 15px;\n}\n\n.invoice-table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n}\n\n.invoice-table thead th:first-child {\n    border-top-left-radius: 5px;\n}\n\n.invoice-table thead th:last-child {\n    border-top-right-radius: 5px;\n}\n\n.invoice-table tbody tr:last-child td:first-child {\n    border-bottom-left-radius: 5px;\n}\n\n.invoice-table tbody tr:last-child td:last-child {\n    border-bottom-right-radius: 5px;\n}\n\n.pagination-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px;\n    border-top: 1px solid #ddd;\n    margin-top: 10px;\n}\n/* .table-responsive {\n    overflow: auto !important;\n} */\n\n.action-dropdown {\n    position: relative;\n    display: inline-block;\n}\n\n.action-menu {\n    position: absolute;\n    right: 0;\n    top: 100%;\n    z-index: 1000;\n    display: none;\n    min-width: 160px;\n    background-color: #fff;\n    border-radius: 5px;\n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n    padding: 8px 0;\n    transition: all 0.2s ease-in-out;\n    pointer-events: auto; \n}\n\n.action-dropdown:hover .action-menu {\n    display: block;\n}\n\n.action-dropdown-item {\n    padding: 10px 15px;\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    cursor: pointer;\n    transition: background 0.2s ease-in-out;\n}\n\n.action-dropdown-item:hover {\n    background-color: #e7e8e9 !important; \n    color: #000;\n}\n@media (max-width: 576px) {\n    .table-wrapper {\n        display: block;\n        max-height: 300px; \n        overflow-y: auto; \n        overflow-x: auto; \n        position: relative;\n        width: 100%;\n    }\n\n    .table thead {\n        position: sticky;\n        top: 0;\n        background-color: #fff; \n        z-index: 10;\n    }\n\n    .table {\n        width: max-content; \n        min-width: 100%; \n        table-layout: auto;\n    }\n\n    .table th, \n    .table td {\n        white-space: nowrap; \n        padding: 8px 12px; \n    }\n}\n\n.custom-select-width {\n    width: 300px; /* Adjust as needed */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
